<template>
  <div class="spot-the-not-container">
    <div class="timer"><h3>:90</h3></div>
    <div class="spot-the-not">
      <Chapter chapter="2" />
      <Title title="Spot The Not" />
      <TransparentBox>
        <p class="bold">You have <span class="orange">90 seconds</span> to identify and select all safety hazards in the given scene.</p>
        <p>There are 1-3 hazards in each image. You may skip questions, but points will be deducted.</p>
        <img src="../assets/spot-the-not-image.png" class="spot-the-not-img" />
        <router-link to="/spot-the-not/images">
          <Button color="orange" buttonText="Play!" path="login" class="button"></Button>
        </router-link>
      </TransparentBox>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import Title from '@/components/Title.vue'
import Chapter from '@/components/Chapter.vue'
import TransparentBox from '@/components/TransparentBox.vue'

export default {
  name: 'spot-the-not',
  components: {
    Button,
    Title,
    Chapter,
    TransparentBox,
  },
  props: {
    heading: String,
    color: String,
    buttonText: String,
    path: String,
    chapter: Number
  },
  mounted() {
    this.$ga.page('/spot-the-not')
  }
}
</script>

<style scoped>
  .spot-the-not {
    left: 50%;
    position: absolute;
    top: 300px;
    transform: translateX(-50%);
  }

  .spot-the-not-img {
    position: absolute;
    right: -100px;
    top: 100px;
  }

  .button {
    bottom: -38px;
    left: 100px;
    position: absolute;
  }

  .orange {
    color: #fdba07;
  }

  p {
    color: #fff;
    font-size: 32px;
    text-align: left;
    max-width: 605px;
    margin: 20px 0;
  }

  .bold {
    font-size: 36px;
    font-weight: bold;
  }

  .timer {
    background: url('../assets/timer_bg.png') top center no-repeat;
    height: 210px;
    position: absolute;
    left: 50%;
    margin-bottom: 50px;
    top: 0;
    transform: translateX(-50%);
    width:279px;
  }

  h3 {
    bottom:40px;
    color: #fff;
    font-size: 62px;
    font-weight: 900;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
  }
</style>